import { render, staticRenderFns } from "./db.vue?vue&type=template&id=ae68e9dc"
import script from "./db.vue?vue&type=script&lang=js"
export * from "./db.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports